import React from "react";
import { Section, Reveal, Icon, Button } from "../components/primitives.jsx";

export function NotFound({ go, c, radius = 16 }) {
  return (
    <main style={{ fontFamily: "var(--font-sans)" }}>
      <Section tone="page" pad="clamp(4rem, 10vw, var(--space-16))">
        <Reveal>
          <div style={{ maxWidth: 560, margin: "0 auto", textAlign: "center" }}>
            <span style={{ display: "inline-flex", width: 64, height: 64, borderRadius: 999, background: "var(--red-50)", color: "var(--brand-red)", alignItems: "center", justifyContent: "center" }}>
              <Icon name="compass" size={30} />
            </span>
            <div style={{ marginTop: "var(--space-5)", fontFamily: "var(--font-mono)", fontWeight: 700, fontSize: "var(--text-sm)", letterSpacing: "0.12em", color: "var(--brand-red)" }}>404</div>
            <h1 style={{ margin: "10px 0 0", fontFamily: "var(--font-display)", fontWeight: 800, fontSize: "clamp(2rem, 5vw, var(--text-3xl))", letterSpacing: "var(--tracking-tighter)", color: "var(--brand-ink)" }}>{c.notFoundTitle}</h1>
            <p style={{ margin: "16px 0 0", fontSize: "var(--text-md)", lineHeight: 1.65, color: "var(--text-body)" }}>{c.notFoundText}</p>
            <div style={{ marginTop: "var(--space-7)", display: "flex", gap: "var(--space-3)", justifyContent: "center", flexWrap: "wrap" }}>
              <Button variant="primary" size="lg" onClick={() => go("home")} iconLeft={<Icon name="arrow-left" size={18} color="#fff" />}>{c.nav.links[0].label}</Button>
              <Button variant="secondary" size="lg" onClick={() => go("contact")}>{c.nav.contact}</Button>
            </div>
          </div>
        </Reveal>
      </Section>
    </main>
  );
}
